import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import {
  SkyDropdownMessage,
  SkyDropdownMessageType
} from '../dropdown';

import {
  SkySortService
} from './sort.service';


export class SkySortComponent {
  public dropdownController = new Subject<SkyDropdownMessage>();

  public dropdownClicked() {
    this.dropdownController.next({
      type: SkyDropdownMessageType.Close
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sort',
  styles: [`.sky-sort-menu-heading {
  background-color: transparent;
  border: none;
  display: block;
  margin: 4px;
  min-width: 160px;
  text-align: left;
  transition: background-color 150ms;
  padding: 3px 20px;
  text-align: left;
  width: 100%;
}

.sky-sort-heading-divider {
  margin: 0;
  height: 1px;
  overflow: hidden;
  background-color: #eeeeef;
}
`],
  template: `<div class="sky-sort">
  <sky-dropdown
    buttonType="sort"
    [title]="'sort_button_label' | skyResources"
    [messageStream]="dropdownController">
    <sky-dropdown-menu (click)="dropdownClicked()">
      <div class="sky-sort-menu-heading sky-subsection-heading">
        {{'sort_menu_heading' | skyResources}}
      </div>
      <div class="sky-sort-heading-divider">
      </div>
      <ng-content></ng-content>
    </sky-dropdown-menu>
  </sky-dropdown>
</div>
`,
  providers: [
    SkySortService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
